<template>
  <div style="background-color:#f4f4f4;">
    <navCom :navActive="navActive"></navCom>
    <div class="current-location">
      <i class="current-location-icon"><img src="../../static/images/zmr-images/address-icon.png" width="100%"></i>
      <p class="current-location-txt">
        <span>您现在的位置：</span>
        <router-link to="/">
          <a href="javascript:;">首页</a>
        </router-link>
        <span class="symbol">></span>
        <a href="javascript:;">客服</a></p>
    </div>
    <div class="service-box">
      <i>
        <img src="../../static/images/zmr-images/service-top.png" alt="">
      </i>
      <div class="service-phone">
        <i>
          <img src="../../static/images/zmr-images/service-icon.png" alt="">
        </i>
        <div class="service-phone-text">
          <p>24小时服务热线</p>
          <p>{{tel}}</p>
        </div>
      </div>
    </div>
    <footerCom></footerCom>
  </div>
</template>
<script>
  import navCom from '../components/welcome-nav'
  import footerCom from '../components/foot'
  import tool from '../assets/js/tool'
  export default {
    name: 'service',
    data() {
      return {
        navActive: 4, //当前导航
        tel:''
      }
    },
    components: {
      navCom,
      footerCom
    },
    mounted() {
      let data = {};
      tool.postData('Customer_Service/index', data, (res) => {
        this.tel=res.data.data.tel
      })
    }
  }
</script>

<style>
  .current-location{
    padding: 27px 0;
    width: 1220px;
    margin:0 auto;
    box-sizing: border-box;
  }
  .current-location-icon{
    width: 13px;
    display: inline-block;
  }
  .current-location-txt{
    display: inline-block;
    vertical-align: bottom;
    margin-left: 4px;
    color: #727272;
    font-size: 16px;
  }
  .current-location-txt a{
    color: #727272;
    font-size: 16px;
  }
  .current-location-txt a:last-child{
    color: #494949
  }
  .symbol{
    margin: 0 5px;
  }
  .service-box{
    height: 925px;
    width:1200px;
    margin:0 auto;
    padding:38px;
    box-sizing: border-box;
    background-color: #fff;
  }
  .service-box>i{
    display: block;
    width: 100%;
    height:308px;
    overflow: hidden;
    margin-bottom: 40px;
  }
  .service-box>i>img{
    height: 100%;
    width: 100%;
  }
  .service-phone{
    box-shadow:0 0 20px #ccc;
    border-radius: 20px;
    padding:25px;
    box-sizing: border-box;
    height: 160px;
    display:flex;
  }
  .service-phone i img{


    width:78px;
    height:71px;
    margin-right: 48px;
  }
  .service-phone-text{
    line-height: 50px;
  }
  .service-phone-text p:first-child{
    font-size:30px;
    color: #1c1b1b;
    font-weight: bold;
  }
  .service-phone-text p:last-child{
    font-size: 24px;
    color: #7f7e7e;
  }
</style>



// WEBPACK FOOTER //
// src/pages/service.vue